import React from 'react';
import { Redirect } from 'react-router';
import { RouteConfig } from 'react-router-config';

import { BabkaSetupStepsLayout, MainLayout, RenderChild, SetupStepsLayout } from '../components';
import {
  AgeRestrictions,
  Analytics,
  ApiSettings,
  BabkaLoginClient,
  CallbackUrlSettings,
  ChangeAuthMethod,
  CreateLogin,
  CustomizationWidget,
  Dashboard,
  EmailCustomization,
  EmailCustomProvider,
  EmailSettings,
  EnterpriseConnections,
  Miscellaneous,
  MultiFactorAuthentication,
  Navigation,
  OauthSettings,
  Passkey,
  PasswordlessTypeSettings,
  PasswordSettings,
  PlatformSettings,
  Signature,
  SignUpSettings,
  SMSCustomization,
  SMSCustomProvider,
  SocialConnection,
  SocialSettings,
  TermsAndPolicies,
  UserAttributes,
  UserDataStorage,
  UsernameSettings,
  Users,
  UserSettings,
  UserSupplementaryInfo,
  WidgetBuilder
} from '../pages';
import { routeBuilder } from './utils';

const notFoundRedirect = routeBuilder('*', () => <Redirect to="/not-found" />);

export const routes = (path: string): RouteConfig => {
  return routeBuilder(`${path}/`, MainLayout, {
    routes: [
      routeBuilder(`${path}/`, Dashboard, {
        exact: true
      }),
      routeBuilder(`${path}/create`, CreateLogin, {
        exact: true
      }),
      routeBuilder(`${path}/analytics`, Analytics, {
        exact: true
      }),
      routeBuilder(`${path}/:projectId/change-method`, ChangeAuthMethod, { exact: true }),
      routeBuilder(`${path}/:projectId/user-database/users`, Users, { exact: true }),
      routeBuilder(`${path}/:projectId/user-database/user/:userId/settings`, UserSettings, {
        exact: true
      }),
      routeBuilder(`${path}/:projectId/customization/widget-editor`, WidgetBuilder, {
        exact: true
      }),
      routeBuilder(`${path}/babka-login-client`, BabkaSetupStepsLayout, {
        routes: [
          routeBuilder(`${path}/babka-login-client/:clientId`, BabkaLoginClient, {
            exact: true
          })
        ]
      }),
      routeBuilder(`${path}/:projectId`, SetupStepsLayout, {
        routes: [
          routeBuilder(`${path}/:projectId/navigation`, Navigation, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/settings/callback-urls`, CallbackUrlSettings, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/settings/sign-up`, SignUpSettings, { exact: true }),
          routeBuilder(`${path}/:projectId/settings/email`, EmailSettings, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/settings/username`, UsernameSettings, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/settings/password`, PasswordSettings, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/settings/passwordless-type`, PasswordlessTypeSettings, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/settings/api`, ApiSettings, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/security/oauth2`, OauthSettings, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/security/signature`, Signature, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/security/mfa`, MultiFactorAuthentication, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/authentication/social-connection`, SocialConnection, {
            exact: true
          }),
          routeBuilder(
            `${path}/:projectId/authentication/social-connection/:socialName`,
            SocialSettings,
            { exact: true }
          ),
          routeBuilder(`${path}/:projectId/authentication/platform-settings`, PlatformSettings, {
            exact: true
          }),
          routeBuilder(
            `${path}/:projectId/authentication/enterprise-connections`,
            EnterpriseConnections,
            {
              exact: true
            }
          ),
          routeBuilder(`${path}/:projectId/authentication/passkey`, Passkey, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/authentication/miscellaneous`, Miscellaneous, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/user-database/storage`, UserDataStorage, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/user-database/supplementary`, UserSupplementaryInfo, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/user-database/attributes`, UserAttributes, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/providers/email`, EmailCustomProvider, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/providers/sms`, SMSCustomProvider, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/customization/widget`, CustomizationWidget, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/customization/email`, EmailCustomization, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/customization/sms`, SMSCustomization, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/legal-settings/terms-and-policies`, TermsAndPolicies, {
            exact: true
          }),
          routeBuilder(`${path}/:projectId/legal-settings/age-restrictions`, AgeRestrictions, {
            exact: true
          }),
          notFoundRedirect
        ]
      }),
      notFoundRedirect
    ]
  });
};

export const insideRoutes = (path: string): RouteConfig => {
  return routeBuilder('', RenderChild, {
    routes: [routes(path), notFoundRedirect]
  });
};
